export const transformEntityToCard = (entity) => {
	const targetSize = Number(entity.target_size) || 0;
	const totalCommitments = Number(entity.total_commitments) || 0;
	const progressPercent =
		targetSize > 0 ? (totalCommitments / targetSize) * 100 : 0;
	const isAtOrOverTarget = targetSize > 0 && totalCommitments >= targetSize;

	return {
		id: entity.id,
		name: entity.name || 'Unnamed Entity',
		entityType: entity.entity_type || 'Unknown Type',
		status: entity.status || 'Unknown',
		stats: [
			{
				label: 'Target Size',
				value:
					targetSize > 0 ? `$${(targetSize / 1000000).toFixed(1)}M` : 'N/A',
			},
			{
				label: 'Total Commitments',
				value:
					totalCommitments > 0
						? `$${(totalCommitments / 1000000).toFixed(1)}M`
						: '$0',
				valueColor: isAtOrOverTarget ? 'success' : 'primary',
			},
		],
		bar:
			targetSize > 0
				? {
						percent: Math.min(progressPercent, 100),
						color: isAtOrOverTarget ? 'success' : 'primary',
					}
				: null,
		footer: 'Click here for raise dashboard',
		footerHighlight: true,
		activeRaise: false,
	};
};
